import React, { useState } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import "./TagViewComponent.css";
import searchIcon from "../../../../assests/search.svg";
import leftArrow from "../../../../assests/leftArrow.svg";
import editIcon from "../../../../assests/edit-tag.svg";
import filterIcon from "../../../../assests/filterIcon.svg";
import closeIcon from "../../../../assests/cancel.svg";
import searchIconSmall from "../../../../assests/search.svg";
import historyIcon from "../../../../assests/historyIcon.svg";
import CloudUploadIcon from "../../../../assests/UPLOADICON.svg";
import walletTopup from "../../../../assests/walletTopup.svg"
import departmentIcon from "../../../../assests/department-building.svg"
import deactivateicon from "../../../../assests/fluent_tag-off.svg"
import activateicon from "../../../../assests/activateicon.svg"
import { Button } from "react-bootstrap-v5";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";

const TagViewComponent = ({
  corporateId, corporateName, tagData, loading, loadingMore, hasMore, totalElements, onLoadMore, handleConfirmActivate,
  onBackClick, onEditTag, onBulkUpload,
  onSelectTag, onSelectAll, selectedTags, onActivateSelected, onDeactivateSelected,
  onChangeDepartment, selectedCount, activeTags, inactiveTags, notActivatedTags, activeTab, onTabChange,
  searchTerm, onSearchChange, onSearch, filteredTags, selectAll, onSelectAllTags,
  showDepartmentFilter, onToggleDepartmentFilter, departmentFilter, onDepartmentFilterChange,
  departments, onClearDepartmentFilter, showBalanceFilter, onToggleBalanceFilter,
  tempBalanceFilterType, onTempBalanceFilterTypeChange, tempBalanceAmount, onTempBalanceAmountChange,
  onApplyBalanceFilter, onClearBalanceFilter,
  // Recharge Modal
  showRechargeModal, rechargeAmount, rechargeLoading, showSuccessPopup, rechargeResult,
  onOpenRechargeModal, onCloseRechargeModal, onRechargeAmountChange, onReasonChange, onSubmitRecharge,
  onCloseSuccessPopup, isRechargeValid, displayTags, remainingCount, reason,
  // Deactivate Confirmation Modal
  showDeactivateModal, deactivateLoading, onCloseDeactivateModal, onConfirmDeactivate,
  // Change Department Modal
  showDeptModal, deptSearchTerm, onDeptSearchChange, filteredDepartments, showDeptDropdown: propShowDeptDropdown,
  onSelectDepartment, selectedDepartmentName, deptChangeLoading, onCloseDeptModal,
  onSubmitDeptChange, isDeptValid, deptSuccessPopup, deptChangeResult, onCloseDeptSuccessPopup,
  // Bulk Upload Modal
  showBulkUploadModal, bulkUploading, bulkUploadProgress, selectedFile, onFileSelect, onFileUpload,
  onCloseBulkUploadModal, onCancelFile, bulkUploadHeading,
  // Activate Success Popup
  showActivateSuccessPopup, activateResult, onCloseActivateSuccessPopup,
  // Not Activated Select All
  onNotActivatedSelectAll, notActivatedAllSelected, notActivatedSelectedCount, notActivatedTotalCount,
  // Department List for Popup
  departmentListForPopup = []
}) => {
  const navigate = useNavigate();

  // Local state for department dropdown
  const [localShowDeptDropdown, setLocalShowDeptDropdown] = useState(false);

  // Use prop if provided, otherwise use local state
  const showDeptDropdown = propShowDeptDropdown !== undefined ? propShowDeptDropdown : localShowDeptDropdown;
  const setShowDeptDropdown = (value) => {
    if (propShowDeptDropdown !== undefined) {
      setLocalShowDeptDropdown(value);
    } else {
      setLocalShowDeptDropdown(value);
    }
  };

  const amountPerTag = parseFloat(rechargeAmount) || 0;
  const totalAmount = amountPerTag * selectedCount;

  // Check if operations should be shown (only on Active tab)
  const showOperations = activeTab === 'active';
  const isNotActivatedView = activeTab === 'notActivated';
  const isInactiveView = activeTab === "inactive";

  // Handle view history click
  const handleViewHistory = (uid) => {
    navigate(`/home/walletandtags/tag-usage-history/${uid}`, {
      state: { tagUid: uid }
    });
  };

  // Group tags by department for Not Activated view
  const groupTagsByDepartment = (tags) => {
    const grouped = {};
    tags.forEach(tag => {
      const deptName = tag.department_name || tag.department || 'Unknown';
      if (!grouped[deptName]) {
        grouped[deptName] = {
          name: deptName,
          tags: [],
          count: 0
        };
      }
      grouped[deptName].tags.push(tag);
      grouped[deptName].count++;
    });
    return Object.values(grouped);
  };

  const groupedDepartments = isNotActivatedView && filteredTags ? groupTagsByDepartment(filteredTags) : [];

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) onFileSelect(file);
  };

  // Handle department select - single click
  const handleDepartmentClick = (dept) => {
    onSelectDepartment(dept);
    setShowDeptDropdown(false);
  };

  // Load More Component - Inside Table Wrapper
  const LoadMoreButton = () => (
    <div className="tag-view-load-more-container">
      {loadingMore ? (
        <div className="tag-view-loading-more">
          <div className="spinner"></div>
          <span>Loading more tags...</span>
        </div>
      ) : hasMore ? (
        <button className="tag-view-load-more-btn" onClick={onLoadMore}>
          Load More
        </button>
      ) : (
        (filteredTags?.length > 0 || groupedDepartments?.length > 0) && (
          <div className="tag-view-load-more-complete" />
        )
      )}
    </div>
  );

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="tag-view-main-container">
            <Sidebar />
            <div className="tag-view-main-content">
              {/* Header */}
              <div className="tag-view-header">
                <button onClick={onBackClick} className="tag-view-back-btn">
                  <img src={leftArrow} alt="Back" />
                </button>
                <h1>Tag Dashboard</h1>
              </div>

              {/* Search Section */}
              <div className="tag-view-search-section">
                <div className="tag-view-search-bar">
                  <input
                    type="text"
                    placeholder="Search By Tag ID"
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                    className="tag-view-search-input"
                  />
                </div>
                {/* Bulk Upload Button - Hide on Not Activated Tab */}
                {!isNotActivatedView && (
                  <Button onClick={onBulkUpload} className="tag-view-bulk-upload-btn">Bulk Upload</Button>
                )}
                {/* Select All Button - Show only on Not Activated Tab */}
                {isNotActivatedView && (
                  <div className="tag-view-not-activated-select-all" onClick={onNotActivatedSelectAll}>
                    <span className="select-all-icon">
                      {notActivatedAllSelected ? "✓" : "☐"}
                    </span>
                    <span className="select-all-text">
                      Select All ({notActivatedSelectedCount}/{notActivatedTotalCount})
                    </span>
                  </div>
                )}
              </div>

              {/* Stats Cards */}
              <div className="tag-view-stats">
                <div
                  className={`tag-view-stat-item ${activeTab === 'active' ? 'active-tab' : ''}`}
                  onClick={() => onTabChange('active')}
                >
                  <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                    <span style={{ width: "20px", height: "20px", backgroundColor: "#14AE78", borderRadius: "50%" }}></span>
                    <span className="tag-view-stat-label">Active Tags</span>
                  </div>
                  <span className="tag-view-stat-value active">{activeTags}</span>
                </div>
                <div
                  className={`tag-view-stat-item ${activeTab === 'inactive' ? 'active-tab' : ''}`}
                  onClick={() => onTabChange('inactive')}
                >
                  <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                    <span style={{ width: "20px", height: "20px", backgroundColor: "#FF5151", borderRadius: "50%" }}></span>
                    <span className="tag-view-stat-label">Inactive Tags</span>
                  </div>
                  <span className="tag-view-stat-value inactive">{inactiveTags}</span>
                </div>
                <div
                  className={`tag-view-stat-item ${activeTab === 'notActivated' ? 'active-tab' : ''}`}
                  onClick={() => onTabChange('notActivated')}
                >
                  <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                    <span style={{ width: "20px", height: "20px", backgroundColor: "#80B7FF", borderRadius: "50%" }}></span>
                    <span className="tag-view-stat-label">Added But Not Activated</span>
                  </div>
                  <span className="tag-view-stat-value" style={{ fontSize: "28px", color: "#111", marginLeft: "30px" }}>{notActivatedTags}</span>
                </div>
              </div>

              {/* Table View for Active/Inactive Tabs */}
              {!isNotActivatedView && (
                <div className="tag-view-table-wrapper">
                  <div className="tag-view-table-container">
                    <table className="tag-view-table">
                      <thead>
                        <tr>
                          <th className="tag-view-checkbox-col">
                            <input
                              type="checkbox"
                              checked={selectAll && filteredTags.length > 0}
                              onChange={onSelectAllTags}
                              className="tag-view-checkbox"
                            />
                          </th>
                          <th>Tag ID</th>
                          <th className="tag-view-filter-cell">
                            Department
                            <img
                              src={filterIcon}
                              alt="filter"
                              className="tag-view-filter-icon"
                              onClick={onToggleDepartmentFilter}
                            />
                            {showDepartmentFilter && (
                              <div className="tag-view-filter-dropdown tag-view-department-dropdown">
                                <select
                                  value={departmentFilter}
                                  onChange={(e) => onDepartmentFilterChange(e.target.value)}
                                  className="tag-view-filter-select-dropdown"
                                >
                                  <option value="">All Departments</option>
                                  {departments.map((dept, idx) => (
                                    <option key={idx} value={dept.name}>{dept.name}</option>
                                  ))}
                                </select>
                                <button className="tag-view-clear-filter-btn" onClick={onClearDepartmentFilter}>
                                  Clear Filter
                                </button>
                              </div>
                            )}
                          </th>
                          <th className="tag-view-filter-cell">
                            Balance
                            <img
                              src={filterIcon}
                              alt="filter"
                              className="tag-view-filter-icon"
                              onClick={onToggleBalanceFilter}
                            />
                            {showBalanceFilter && (
                              <div className="tag-view-filter-dropdown tag-view-balance-dropdown">
                                <div className="tag-view-balance-filter-options">
                                  <label className="tag-view-balance-option">
                                    <input
                                      type="radio"
                                      name="balanceFilter"
                                      value="above"
                                      checked={tempBalanceFilterType === 'above'}
                                      onChange={(e) => onTempBalanceFilterTypeChange(e.target.value)}
                                    />
                                    Above Amount
                                  </label>
                                  <label className="tag-view-balance-option">
                                    <input
                                      type="radio"
                                      name="balanceFilter"
                                      value="below"
                                      checked={tempBalanceFilterType === 'below'}
                                      onChange={(e) => onTempBalanceFilterTypeChange(e.target.value)}
                                    />
                                    Below Amount
                                  </label>
                                </div>
                                <input
                                  type="number"
                                  placeholder="Enter amount"
                                  value={tempBalanceAmount}
                                  onChange={(e) => onTempBalanceAmountChange(e.target.value)}
                                  className="tag-view-balance-amount-input"
                                />
                                <div className="tag-view-filter-actions">
                                  <button className="tag-view-apply-filter-btn" onClick={onApplyBalanceFilter}>
                                    Apply Filter
                                  </button>
                                  <button className="tag-view-clear-filter-btn" onClick={onClearBalanceFilter}>
                                    Clear Filter
                                  </button>
                                </div>
                              </div>
                            )}
                          </th>
                          <th>Status</th>
                          <th>View</th>
                         </tr>
                      </thead>
                      <tbody>
                        {filteredTags?.length > 0 ? (
                          filteredTags.map((tag, index) => (
                            <tr key={tag.id || index}>
                              <td className="tag-view-checkbox-col">
                                <input
                                  type="checkbox"
                                  checked={!!selectedTags?.[tag.id || tag.uid]}
                                  onChange={() => onSelectTag(tag)}
                                  className="tag-view-checkbox"
                                />
                              </td>
                              <td className="tag-view-tag-id-cell">{tag.uid}</td>
                              <td>{tag.department_name || tag.department || '-'}</td>
                              <td className="tag-view-balance-cell">
                                ₹{(tag.balance || 0).toLocaleString('en-IN')}
                              </td>
                              <td>
                                <span className={`tag-view-status-badge ${tag.status === 'active' ? 'active' : tag.status === 'new' ? 'new' : 'inactive'}`}>
                                  {tag.status === 'active' ? 'Active' : tag.status === 'new' ? 'New' : 'Inactive'}
                                </span>
                              </td>
                              <td className="tag-view-action-cell">
                                <div className="tag-view-action-buttons">
                                  <button
                                    className="tag-view-history-btn"
                                    onClick={() => handleViewHistory(tag.uid)}
                                    title="View Usage History"
                                  >
                                    <img src={historyIcon} alt="history-icon" />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="tag-view-no-results">No tags found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* Load More Button - Inside Table Wrapper */}
                  <LoadMoreButton />
                </div>
              )}

              {/* Grid View for Not Activated Tab */}
              {isNotActivatedView && (
                <>
                  <div className="tag-view-not-activated-container">
                    {groupedDepartments.length > 0 ? (
                      groupedDepartments.map((department, deptIdx) => (
                        <div key={deptIdx} className="tag-view-dept-card">
                          <div className="tag-view-dept-header">
                            <h3>Department {deptIdx + 1} - {department.name}</h3>
                            <span className="tag-view-dept-count">({department.count}/{department.count} Tags)</span>
                          </div>
                          <div className="tag-view-dept-tags-grid">
                            {department.tags.map((tag, tagIdx) => (
                              <div key={tagIdx} className="tag-view-tag-card">
                                <div className="tag-view-tag-info">
                                  <div className="tag-view-tag-id">
                                    <span className="tag-view-label">Tag ID</span>
                                    <span className="tag-view-value">{tag.uid}</span>
                                  </div>
                                  <div className="tag-view-tag-token">
                                    <span className="tag-view-label">Token</span>
                                    <span className="tag-view-value">{tag.token || '-'}</span>
                                  </div>
                                </div>
                                <div className="tag-view-tag-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={!!selectedTags?.[tag.id || tag.uid]}
                                    onChange={() => onSelectTag(tag)}
                                    className="tag-view-checkbox"
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="tag-view-no-results">No tags found</div>
                    )}
                  </div>
                  {/* Load More Button - Below Grid */}
                  <LoadMoreButton />
                </>
              )}

              {/* Bulk Action Buttons */}
              {!isNotActivatedView && showOperations && selectedCount > 0 && (
                <div className="tag-view-bulk-actions">
                  <div className="tag-view-selected-info">
                    <span className="tag-view-selected-count">{selectedCount} Tags Selected</span>
                  </div>
                  <div className="tag-view-bulk-buttons">
                    <button className="tag-view-bulk-recharge-btn" onClick={onOpenRechargeModal}>
                      <img src={walletTopup} alt="Recharge" style={{ marginRight: "10px" }} />
                      Recharge
                    </button>
                    <button className="tag-view-bulk-change-dept-btn" onClick={onChangeDepartment}>
                      <img src={departmentIcon} alt="Change Department" style={{ marginRight: "10px" }} />
                      Change Dept.
                    </button>
                    <button className="tag-view-bulk-deactivate-btn" onClick={onDeactivateSelected}>
                      <img src={deactivateicon} alt="Deactivate" style={{ marginRight: "10px" }} />
                      Deactivate
                    </button>
                  </div>
                </div>
              )}

              {/* Activate button for Not Activated tab */}
              {isNotActivatedView && selectedCount > 0 && (
                <div className="tag-view-bulk-actions">
                  <div className="tag-view-selected-info">
                    <span className="tag-view-selected-count">{selectedCount} Tags Selected</span>
                  </div>
                  <div className="tag-view-bulk-buttons">
                    <button className="tag-view-bulk-activate-btn" onClick={() => onActivateSelected(selectedTags)}>
                      <img src={activateicon} alt="" style={{ marginRight: "10px" }} />
                      Activate
                    </button>
                  </div>
                </div>
              )}

              {isInactiveView && selectedCount > 0 && (
                <div className="tag-view-bulk-actions">
                  <div className="tag-view-selected-info">
                    <span className="tag-view-selected-count">{selectedCount} Tags Selected</span>
                  </div>
                  <div className="tag-view-bulk-buttons">
                    <button className="tag-view-bulk-activate-btn" onClick={() => handleConfirmActivate(selectedTags)}>
                      <img src={activateicon} alt="" style={{ marginRight: "10px" }} />
                      Activate
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Bulk Upload Modal */}
            {showBulkUploadModal && (
              <div className="tag-view-modal-overlay">
                <div className="tag-view-bulk-upload-modal">
                  <div className="tag-view-modal-header">
                    <h2>{bulkUploadHeading}</h2>
                    <button className="tag-view-modal-close" onClick={onCloseBulkUploadModal}>
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                  <div className="tag-view-modal-body">
                    {bulkUploading ? (
                      <div className="tag-view-upload-progress-container">
                        <div className="tag-view-progress-bar">
                          <div className="tag-view-progress-fill" style={{ width: `${bulkUploadProgress}%` }}></div>
                        </div>
                        <p>Uploading... {bulkUploadProgress}%</p>
                      </div>
                    ) : selectedFile ? (
                      <div className="tag-view-file-preview-container">
                        <div className="tag-view-file-info">
                          <span className="tag-view-file-name">{selectedFile.name}</span>
                          <span className="tag-view-file-size">({(selectedFile.size / 1024).toFixed(1)} KB)</span>
                          <button onClick={onCancelFile} className="tag-view-remove-file-btn">
                            <img src={closeIcon} alt="Remove" />
                          </button>
                        </div>
                        <div className="tag-view-file-actions">
                          <button className="tag-view-cancel-btn" onClick={onCancelFile}>Cancel</button>
                          <button className="tag-view-upload-btn" onClick={() => onFileUpload(selectedFile)}>Upload</button>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="tag-view-drop-zone"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <input
                          type="file"
                          id="csv-upload"
                          accept=".csv"
                          onChange={(e) => onFileSelect(e.target.files[0])}
                          style={{ display: 'none' }}
                        />
                        <img src={CloudUploadIcon} alt="upload" className="tag-view-upload-icon" />
                        <p className="tag-view-upload-text">Drag & drop CSV file here</p>
                        <p className="tag-view-upload-or">or</p>
                        <label htmlFor="csv-upload" className="tag-view-browse-btn">
                          Browse File
                        </label>
                        <p className="tag-view-upload-hint">Supported format: CSV only</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Recharge Modal */}
            {showRechargeModal && (
              <div className="tag-view-modal-overlay">
                <div className="tag-view-recharge-modal">
                  <div className="tag-view-modal-header">
                    <h2>Recharge Tags</h2>
                    <button className="tag-view-modal-close" onClick={onCloseRechargeModal}>
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                  <div className="tag-view-modal-body">
                    <p className="tag-view-modal-description">
                      Amount Will Be Added To All Selected Active Tags
                    </p>
                    <div className="tag-view-selected-tags-list">
                      {displayTags.map((tag, idx) => (
                        <div key={idx} className="tag-view-selected-tag-item">
                          Tag: {tag.uid}
                        </div>
                      ))}
                      {remainingCount > 0 && (
                        <div className="tag-view-selected-tag-more">+ {remainingCount} More</div>
                      )}
                    </div>
                    <div className="tag-view-recharge-form">
                      <label className="tag-view-form-label">Recharge Amount Per Tag (₹)</label>
                      <input
                        type="number"
                        placeholder="Enter Amount Here"
                        value={rechargeAmount}
                        onChange={(e) => onRechargeAmountChange(e.target.value)}
                        className="tag-view-form-input"
                      />
                      <p className="tag-view-form-hint">Minimum ₹100/Tag</p>
                    </div>
                    <div className="tag-view-recharge-form">
                      <label className="tag-view-form-label">Reason for Recharge</label>
                      <textarea
                        placeholder="Enter reason here..."
                        value={reason}
                        onChange={(e) => onReasonChange(e.target.value)}
                        className="tag-view-form-textarea"
                        rows="3"
                      />
                    </div>
                    <div className="tag-view-recharge-summary">
                      <div className="tag-view-summary-row">
                        <span>Recharge Amount Per Tag:</span>
                        <span>₹{amountPerTag.toLocaleString('en-IN')}</span>
                      </div>
                      <div className="tag-view-summary-row">
                        <span>Selected Tags:</span>
                        <span>{selectedCount}</span>
                      </div>
                      <div className="tag-view-summary-row total">
                        <span>Total Amount:</span>
                        <span>₹{totalAmount.toLocaleString('en-IN')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="tag-view-modal-footer">
                    <button className="tag-view-cancel-btn" onClick={onCloseRechargeModal}>
                      Cancel
                    </button>
                    <button
                      className="tag-view-recharge-submit-btn"
                      onClick={onSubmitRecharge}
                      disabled={!isRechargeValid || rechargeLoading}
                    >
                      {rechargeLoading ? "Processing..." : `Recharge (${selectedCount})`}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Recharge Success Popup */}
            {showSuccessPopup && rechargeResult && (
              <div className="tag-view-modal-overlay">
                <div className={`tag-view-result-popup ${rechargeResult.success ? 'success' : 'error'}`}>
                  <div className="tag-view-result-icon-center">
                    {rechargeResult.success ? (
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
                        <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    ) : (
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#f44336" />
                        <path d="M12 8L12 16M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </div>
                  <h2>{rechargeResult.success ? "Recharge Successfully!" : "Recharge Failed"}</h2>
                  {rechargeResult.success ? (
                    <div className="tag-view-result-details">
                      <p>All selected tag has been updated with new balance.</p>
                    </div>
                  ) : (
                    <div className="tag-view-result-details">
                      <p>{rechargeResult.message}</p>
                    </div>
                  )}
                  <button className="tag-view-result-ok-btn" onClick={onCloseSuccessPopup}>
                    OK
                  </button>
                </div>
              </div>
            )}

            {/* Activate Success Popup */}
            {showActivateSuccessPopup && activateResult && (
              <div className="tag-view-modal-overlay">
                <div className={`tag-view-result-popup ${activateResult.success ? 'success' : 'error'}`}>
                  <div className="tag-view-result-icon-center">
                    {activateResult.success ? (
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
                        <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    ) : (
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" fill="#f44336" />
                        <path d="M12 8L12 16M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </div>
                  <h2>{activateResult.success ? "Activated Successfully" : "Activation Failed"}</h2>
                  {activateResult.success ? (
                    <div className="tag-view-result-details">
                      <p>The Selected Tag Is Now Active And Ready For Further Actions.</p>
                    </div>
                  ) : (
                    <div className="tag-view-result-details">
                      <p>{activateResult.message}</p>
                    </div>
                  )}
                  <button className="tag-view-result-ok-btn" onClick={onCloseActivateSuccessPopup}>
                    OK
                  </button>
                </div>
              </div>
            )}

            {/* Deactivate Confirmation Modal */}
            {showDeactivateModal && (
              <div className="tag-view-modal-overlay">
                <div className="tag-view-deactivate-modal">
                  <div className="tag-view-modal-header">
                    <h2>Deactivate this tag?</h2>
                    <button className="tag-view-modal-close" onClick={onCloseDeactivateModal}>
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                  <div className="tag-view-modal-body">
                    <div className="tag-view-selected-tags-list">
                      {displayTags.map((tag, idx) => (
                        <div key={idx} className="tag-view-selected-tag-item">
                          Tag: {tag.uid}
                        </div>
                      ))}
                      {remainingCount > 0 && (
                        <div className="tag-view-selected-tag-more">+ {remainingCount} More</div>
                      )}
                    </div>
                    <p className="tag-view-deactivate-warning">
                      Once Deactivated, All Transactions And Operations Linked To This Tag Will Be Suspended.
                    </p>
                  </div>
                  <div className="tag-view-modal-footer">
                    <button className="tag-view-cancel-btn" onClick={onCloseDeactivateModal}>
                      No, Cancel
                    </button>
                    <button
                      className="tag-view-deactivate-submit-btn"
                      onClick={onConfirmDeactivate}
                      disabled={deactivateLoading}
                    >
                      {deactivateLoading ? "Processing..." : `Yes, Deactivate (${selectedCount})`}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Change Department Modal - Using departmentListForPopup */}
            {showDeptModal && (
              <div className="tag-view-modal-overlay">
                <div className="tag-view-change-dept-modal">
                  <div className="tag-view-modal-header">
                    <h2>Change Department</h2>
                    <button className="tag-view-modal-close" onClick={onCloseDeptModal}>
                      <img src={closeIcon} alt="Close" />
                    </button>
                  </div>
                  <div className="tag-view-modal-body">
                    <p className="tag-view-modal-description">You Are Moving Selected Tags To New Department.</p>
                    <div className="tag-view-selected-tags-list">
                      {displayTags.map((tag, idx) => (
                        <div key={idx} className="tag-view-selected-tag-item">
                          Tag: {tag.uid}
                        </div>
                      ))}
                      {remainingCount > 0 && (
                        <div className="tag-view-selected-tag-more">+ {remainingCount} More</div>
                      )}
                    </div>
                    <div className="tag-view-recharge-form">
                      <label className="tag-view-form-label">Select New Department</label>
                      <div className="tag-view-search-select-wrapper">
                        <div className="tag-view-search-input-container">
                          <img src={searchIconSmall} alt="search" className="tag-view-search-icon-small" />
                          <input
                            type="text"
                            placeholder="Search Or Select Department For Change"
                            value={deptSearchTerm}
                            onChange={(e) => onDeptSearchChange(e.target.value)}
                            className="tag-view-search-select-input"
                          />
                        </div>
                        {showDeptDropdown && filteredDepartments.length > 0 && (
                          <div className="tag-view-departments-dropdown-list">
                            {filteredDepartments.map((dept) => (
                              <div
                                key={dept.id}
                                className="tag-view-dept-option"
                                onClick={() => handleDepartmentClick(dept)}
                              >
                                {dept.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {selectedDepartmentName && (
                        <div className="tag-view-selected-dept-display">
                          Selected: <span className="tag-view-selected-dept-name">{selectedDepartmentName}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tag-view-modal-footer">
                    <button className="tag-view-cancel-btn" onClick={onCloseDeptModal}>
                      No, Cancel
                    </button>
                    <button
                      className="tag-view-move-submit-btn"
                      onClick={onSubmitDeptChange}
                      disabled={!isDeptValid || deptChangeLoading}
                    >
                      {deptChangeLoading ? "Moving..." : `Move (${selectedCount})`}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Department Change Success Popup */}
            {deptSuccessPopup && deptChangeResult && (
              <div className="tag-view-modal-overlay">
                <div className={`tag-view-result-popup ${deptChangeResult.success ? 'success' : 'error'}`}>
                  <div className="tag-view-result-icon-center">
                    {deptChangeResult.success ? (
                      <img src={departmentIcon} alt="Success" style={{ width: "48px", height: "48px" }} />
                    ) : (
                      <div style={{ width: "48px", height: "48px", backgroundColor: "#f44336", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto" }}>
                        <img src={deactivateicon} alt="Failed" style={{ width: "24px", height: "24px" }} />
                      </div>
                    )}
                  </div>
                  <h2>{deptChangeResult.success ? "Moved Successfully!" : "Change Department Failed"}</h2>
                  {deptChangeResult.success ? (
                    <div className="tag-view-result-details">
                      <p><strong>{deptChangeResult.successCount}</strong> tags has been moved to <strong>{deptChangeResult.targetDepartment || selectedDepartmentName}</strong>.</p>
                    </div>
                  ) : (
                    <div className="tag-view-result-details">
                      <p>{deptChangeResult.message}</p>
                    </div>
                  )}
                  <button className="tag-view-result-ok-btn" onClick={onCloseDeptSuccessPopup}>
                    OK
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TagViewComponent;